// extracted by mini-css-extract-plugin
export default {"img":"src_img__aGYlH"};